export const SET_PRODUITS = 'SET_PRODUITS';
export const SET_TOTAL_PRODUITS = 'SET_TOTAL_PRODUITS';
export const SET_PRODUIT = 'SET_PRODUIT';
export const REMOVE_PRODUIT = 'REMOVE_PRODUIT';
export const SET_CRITERE_RECHERCHE_PRODUIT_NON_COM = 'SET_CRITERE_RECHERCHE_PRODUIT_NON_COM';
export const SET_PRODUITS_ASSOCIES = 'SET_PRODUITS_ASSOCIES';
export const SET_TOTAL_PRODUITS_ASSOCIES = 'SET_TOTAL_PRODUITS_ASSOCIES';
export const SET_SELECTION = 'SET_SELECTION';
export const SET_ONGLET_TO_GO = 'SET_ONGLET_TO_GO';
export const SET_SOCIETE_FOR_GET_ALL = 'SET_SOCIETE_FOR_GET_ALL';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
export const SET_CRITERE_RECHERCHE = 'SET_CRITERE_RECHERCHE';
export const SET_PANIER = 'SET_PANIER';
export const CLEAR_PANIER = 'CLEAR_PANIER';
export const ADD_LIGNE_IN_PANIER_AT_END = 'ADD_LIGNE_IN_PANIER_AT_END';
export const DELETE_LIGNE_IN_PANIER = 'DELETE_LIGNE_IN_PANIER';
export const SET_LOGO = 'SET_LOGO';
